import { CMS_FEATURES } from './cms-features';
/** Feature path inside the CMS hash router, e.g. `/card-schemas`. */
export function cmsFeaturePath(pathSegment) {
    return `/${pathSegment}`;
}
/** Whether `pathname` is on this feature (list or nested detail routes). */
export function isCmsFeaturePathActive(pathname, pathSegment) {
    const base = cmsFeaturePath(pathSegment);
    return pathname === base || pathname.startsWith(`${base}/`);
}
/** Whether the user is anywhere inside the CMS app. */
export function isCmsMountPathActive(pathname) {
    return pathname === '/' || CMS_FEATURES.some(f => isCmsFeaturePathActive(pathname, f.pathSegment));
}
/** Resolve the active feature from a host pathname. */
export function resolveActiveCmsFeature(pathname, features) {
    return features.find(f => isCmsFeaturePathActive(pathname, f.pathSegment));
}
/** Build host mega-menu groups from the feature registry (single source of truth). */
export function buildCmsHostTopbarGroups(features) {
    const groups = new Map();
    for (const feature of features) {
        const groupKey = feature.groupLabelKey ?? 'form.cms';
        const items = groups.get(groupKey) ?? [];
        items.push({
            labelKey: feature.labelKey,
            path: cmsFeaturePath(feature.pathSegment),
            authorityKeys: feature.authorityKeys ?? ['ADMIN'],
        });
        groups.set(groupKey, items);
    }
    return Array.from(groups.entries()).map(([labelKey, items]) => ({ labelKey, items }));
}
/** Backward-compatible route segment map derived from features. */
export function buildCmsRouteMap(features) {
    const map = { segment: 'cms' };
    for (const f of features) {
        map[toRouteConstantKey(f.id)] = f.pathSegment;
    }
    return map;
}
/** `card-schemas` → `cardSchemas` for legacy `CMS_ROUTE` keys. */
function toRouteConstantKey(featureId) {
    return featureId.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
}
